import { render, staticRenderFns } from "./materialdetails.vue?vue&type=template&id=1916ea0b&scoped=true&"
import script from "./materialdetails.vue?vue&type=script&lang=js&"
export * from "./materialdetails.vue?vue&type=script&lang=js&"
import style0 from "./materialdetails.vue?vue&type=style&index=0&id=1916ea0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1916ea0b",
  null
  
)

export default component.exports